import { useEffect, useState } from 'react'

const openPickerIds = new Set()
const listeners = new Set()

const emit = () => {
  listeners.forEach(listener => listener())
}

export const setPickerPopoverOpen = (pickerId, open) => {
  if (pickerId == null) {
    return
  }
  const key = String(pickerId)
  if (open) {
    openPickerIds.add(key)
  } else {
    openPickerIds.delete(key)
  }
  emit()
}

export const resetPickerPopoverOpenRegistry = () => {
  openPickerIds.clear()
  emit()
}

const getSnapshot = () => openPickerIds.size > 0

const subscribe = listener => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const useIsAnyTimePickerPopoverOpen = () => {
  const [isOpen, setIsOpen] = useState(getSnapshot)

  useEffect(() => subscribe(() => setIsOpen(getSnapshot())), [])

  return isOpen
}
